module.exports = __webpack_public_path__ + "img/f.c91c0bf4.jpg";